// extracted by mini-css-extract-plugin
export var shapeshifter = "signature_igor-module--shapeshifter--qLzom";
export var play = "signature_igor-module--play--FUGFT";
export var play48 = "signature_igor-module--play48--NAngK";
export var shapeshifterBg = "signature_igor-module--shapeshifterBg--xqZ6Z";